import type { BackendRouteDefinition } from '../types';

export const getMostVisitedPagesRoute = {
  transport: 'api',
  method: 'GET',
  path: '/admin/analytics/most-visited-pages',
  query: ({ monthsBack }: { monthsBack: number }) => ({
    monthsBack,
  }),
} as const satisfies BackendRouteDefinition;
